import React from "react"
import { useOutlet } from "react-router-dom"

export const Workflows = () => {
  const outlet = useOutlet()

  return <>{outlet}</>
}
